export const bodyFont = '"RAGSans1.3Regular","HeeboRegular", sans-serif';
export const boldFont = '"RAGSans1.3Bold","HeeboBold", sans-serif';
export const lightFont = '"RAGSans1.3Light", "HeeboLight", sans-serif';
export const mediumFont = '"HeeboMedium", sans-serif';
export const secondaryLightFont = '"NextExitFOTLight"';
export const baseFont = '"RAGSans1.3"';

